import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getCameraType1List = async () => {
  return axios.get(`${api_base_url}/GetCameraType1`).then((res) => {
    return res;
  });
};

export const addCameraType1 = async (newCameraType1) => {
  const { data } = await axios.post(`${api_base_url}/AddCameraType1`, {
    ...newCameraType1,
  });
  return data;
};

export const deleteCameraType1 = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateCameraType1`, {
    data: ids,
  });
  return data;
};

export const updateCameraType1 = async (editCameraType1) => {
  const { data } = await axios.put(
    `${api_base_url}/EditCameraType1`,
    editCameraType1
  );
  return data;
};
